// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COLORS = "Farby";
export const PRICE = "Cena";
export const RATING = "Hodnotenie";
export const STROLLER_counter_REVIEWS = ["%(counter)s hodnotenie", "%(counter)s hodnotenia", "%(counter)s hodnoten\u00ed"];
export const STROLLERS_COMPARISON = "Porovnaj";
export const STROLLERS_COMPARISON__SHOW_VARIOUS = "Zobraz len rozdielne parametre";
export const STROLLERS_COMPARISON__SHOW_VARIOUS_OR_SAME = "Zobraz aj zhodn\u00e9 parametre";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
export const STROLLER_UNPREPARED_TAG = "Pripravujeme";
export const WIKI_REVIEWS = "Centrum recenzi\u00ed";
